// Schroeven in de viewer herkennen (O-134a). Zonder DOM, zodat de tests het kunnen draaien
// (src/modules/3d/schroeven.test.ts).
//
// De extras van een glTF-node komen bij GLTFLoader op het object van die node. Heeft de node één primitive,
// dan is dat object de Mesh zelf; met meer primitives is het een Group met de meshes als kinderen. Daarom
// zoeken we vanaf de mesh omhoog naar het object met extras.soort "schroef". Een deuvel (extras.soort
// "deuvel", O-135) telt als schroef: hij verschijnt en vliegt in op dezelfde manier.

import type { Object3D } from "three";

/** Het object van de schroef- of deuvelnode waar deze mesh bij hoort, of null als de mesh er geen is. */
export function schroefNode(obj: Object3D): Object3D | null {
  for (let o: Object3D | null = obj; o; o = o.parent) {
    if (o.userData.soort === "schroef" || o.userData.soort === "deuvel") return o;
    // Een onderdeel van het hout: geen schroef, ook niet hoger in de boom.
    if (o.userData.partId !== undefined) return null;
  }
  return null;
}
